const carRental = {
  carRental: "Autoverhuur", // translated
  carRentals: "Autoverhuur", // translated
  pickUpPoint: "Ophaalpunt", // translated
  dropOffPoint: "Afleverpunt", // translated
  pickUpDate: "Ophaaldatum", // translated
  dropOffDate: "Afleverdatum", // translated
  pickUp: "Ophalen", // translated
  dropOff: "Afzetten", // translated
  edit: "Bewerking", // translated
  fuelPolicy: "Brandstofbeleid", // translated
  pickUpLocation: "Ophaalplaats", // translated
  mileage: "Kilometerstand", // translated
  transmission: "Overdragen", // translated
  airCondition: "Airco", // translated
  minimumAge: "Minimum leeftijd", // translated
  maximumAge: "Maximale leeftijd", // translated
  providerAddress: "Adres van de aanbieder", // translated
  providerPhone: "Telefoon provider", // translated
  driverInfo: "Bestuurdersinformatie", // translated
  driversInfo: "Bestuurdersinformatie", // translated
  differentDropOff: "Afzetten op andere locatie", // translated
  maxPassengers: "Maximaal aantal passagiers", // translated
  budget: "Begroting", // translated
  provider: "Aanbieder", // translated
  carModel: "Auto model", // translated
  numOfDoors: "Aantal deuren", // translated
  fuelType: "Brandstoftype", // translated
  driverAge: "Leeftijd van de bestuurder", // translated
  workingHours: "Werkuren", // translated
  driverNationality: "Nationaliteit van de bestuurder", // translated
  carRentalRate: "Tarief autoverhuur", // translated
  dueNow: "Nu verschuldigd", // translated
  duePickUp: "Te betalen bij ophalen", // translated
  toViewOfferPDF: "Om een PDF-document te bekijken met alle huurvoorwaarden van deze aanbieding, alstublieft", // translated
  toViewTermsAndCondPDF: "Om de toepasselijke CARNECT-voorwaarden te bekijken, alstublieft", // translated
};

export default carRental;
